import * as React from 'react';
import { ReduxFormContext } from 'redux-form';
import { Label } from '@gandi/ui';
import ErrorMessage from '../controls/ErrorMessage';
import Fieldset from '../controls/Fieldset';
import HelpMessage from '../controls/HelpMessage';
import Legend from '../controls/Legend';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function FormGroup(props) {
  const reduxForm = React.useContext(ReduxFormContext);
  const {
    submitFailed
  } = reduxForm;
  const showError = !!props.meta.error && (props.meta.touched || submitFailed) || !!props.error;
  const renderLabel = () => {
    if (props.legend) {
      return /*#__PURE__*/_jsx(Legend, {
        required: props.required,
        children: props.legend
      });
    }
    if (props.label) {
      return /*#__PURE__*/_jsx(Label, {
        target: props.id || props.input?.name,
        popoverIcon: props.popoverIcon,
        required: props.required,
        disabled: props.disabled,
        children: props.label
      });
    }
    return null;
  };
  return /*#__PURE__*/_jsxs(Fieldset, {
    error: showError,
    children: [renderLabel(), props.children, showError && /*#__PURE__*/_jsx(ErrorMessage, {
      text: props.meta.error || props.error
    }), props.meta.warning && /*#__PURE__*/_jsx(HelpMessage, {
      text: props.meta.warning
    }), props.help && /*#__PURE__*/_jsx(HelpMessage, {
      text: props.help
    })]
  });
}
export default FormGroup;